export default () => {
  const { $t } = useNuxtApp()

  const listOrderFrom = [
    {
      label: $t('labels.haveQuote'),
      value: 'QUOTE'
    },
    {
      label: $t('labels.notHaveQuote'),
      value: 'CUSTOMER_REQUEST'
    }
  ]

  const listWorkingTimeRequest = [
    {
      label: $t('labels.nodeModule.overTime'),
      value: 'overTime'
    },
    {
      label: $t('labels.holiday'),
      value: 'holiday'
    }
  ]

  const EOrderStatuses = {
    CANCEL: -1, // Huỷ
    UNFULFILLED: 1, // Chưa thực hiện
    PROCESSING: 2, // Đang thực hiện
    COMPLETE: 3 // Hoàn thành
  }

  const EAllocationStatus = {
    CANCEL: -1,
    NOT_QUOTE: 1, // ko có quote
    NOT_OPTIMAL_TIME: 2, // ko có thời gian tối ưu
    NOT_QUOTE_AND_OPTIMAL_TIME: 3, // ko có quote và thời gian tối ưu
    WAITING: 4, // chờ phân bổ
    PROCESSING: 5, // Phân bổ dang dỡ
    COMPLETE: 6 // Hoàn tất phân bổ
  }

  const checkShowCancel = (order: any) => {
    const status = order.status

    if (typeof status !== 'number') {
      return false
    }

    if ([EOrderStatuses.CANCEL].includes(status)) {
      return false
    }

    return true
  }

  return {
    listOrderFrom,
    listWorkingTimeRequest,
    EOrderStatuses,
    EAllocationStatus,
    checkShowCancel
  }
}
